
import { defineComponent, PropType, ref } from 'vue'
import QForm from 'quasar/src/components/form/QForm.js';
import { useFormModule } from '@/modules/_shared/forms'
import MembersFormFieldRole from '@/components/members/form-fields/role.vue'
import { useAclModule } from '@/modules/acl'
import { useOrganizationModule } from '@/modules/organizations'

export default defineComponent({
    name: 'members-edit-member-role-form',
    components: { MembersFormFieldRole },
    props: {
        organizationId: {
            type: String,
            required: true
        },
        memberId: {
            type: String,
            required: true
        },
        role: {
            type: String,
            required: true
        },
        updateCallback: {
            type: Function as PropType<(t: string) => void>,
            required: true
        }
    },
    setup (props, { emit }) {
        const { getMemberOrganizationProfile } = useOrganizationModule()
        const { updateMemberRole, deleteMemberRole } = useAclModule()
        const { submitForm, createOnSuccess } = useFormModule()
        const form = ref<QForm>()

        const roleModel = ref(props.role)

        const sendRequest = async () => {
            if (roleModel.value === null) {
                await deleteMemberRole(
                    props.memberId,
                    {
                        role: props.role
                    })
            } else {
                await updateMemberRole(
                    props.memberId,
                    {
                        role: roleModel.value,
                        customPermissions: []
                    })
            }

            await getMemberOrganizationProfile(props.organizationId as string, props.memberId as string)
        }
        const onCloseDialog = () => emit('closeDialog')

        const onSubmit = () => submitForm(
            form.value,
            sendRequest,
            createOnSuccess('Member role has been updated')
        ).then(() => {
            onCloseDialog()
            props.updateCallback(roleModel.value)
        })

        return {
            roleModel,
            onSubmit,
            form,
            onCloseDialog
        }
    }
})
